import CrmPropostaAtividadeService from "@/services/CrmPropostaAtividadeService";
import store from "@/store"
import moment from "moment"
export const actions = {
  cadastrarAtividadeCrmProposta: ({ commit, dispatch }) => {
    commit("setAtividadeCrmProposta", {
      id: "",
      descricao: "",
      data_atividade: moment().format("YYYY-MM-DD"),
      hora_atividade: moment().format("HH:ss"),
      pos_venda_id: "",
    }),
      dispatch("setModalCadastroAtividadeCrmProposta", true);
  },
  listarAtividadesCrmProposta: ({ commit }, data) => {
    commit("setOverlay", true);
    CrmPropostaAtividadeService.listar(data)
      .then((res) => {
        commit("setOverlay", false);
        commit("setAtividadesCrmProposta", res.data);
      })
      .catch((e) => {
        commit("setOverlay", false);
        console.log(e);
      });
  },
  visualizarAtividadeCrmProposta: ({ commit, dispatch }, data) => {
    commit("setAtividadeCrmProposta", { ...data });
    dispatch("setModalCadastroAtividadeCrmProposta", true);
  },
  salvarAtividadeCrmProposta: ({ commit, dispatch }, data) => {
    commit("setOverlay", true);
    CrmPropostaAtividadeService.salvar(data)
      .then((res) => {
        // commit('addCrmProposta', res.data)
        commit("setAtividadeCrmProposta", res.data);
        commit("setOverlay", false);
        commit("snackbarSuccess", "Registro salvo.");
        dispatch("listarAtividadesCrmProposta", store.getters.getCrmProposta);
        dispatch("setModalCadastroAtividadeCrmProposta", false);
        dispatch("listarCrmPropostas", { limite: 20, page: 1})
      })
      .catch((e) => {
        if (e.response.status == 422) {
          commit("alertError", e.response.data.errors);
        }
        console.log(e);
        commit("setOverlay", false);
        commit("snackbarError", "Erro ao cadastrar.");
      });
  },
  atualizarAtividadeCrmProposta: ({ commit, dispatch }, data) => {
    commit("setOverlay", true);
    CrmPropostaAtividadeService.atualizar(data)
      .then((res) => {
        commit("setOverlay", false);
        commit("snackbarInfo", "Registro atualizado.");
        dispatch("listarCrmPropostas", { limite: 20, page: 1})
      })
      .catch((e) => {
        // if(e.response.status == 422){
        //     commit('alertError', e.response.data.errors)
        // }
        console.log(e);
        commit("setOverlay", false);
        commit("snackbarError", "Erro ao atualizar.");
      });
  },
  excluirAtividadeCrmProposta: ({ commit, dispatch }, id) => {
    commit("setOverlay", true);
    dispatch("setModalExcluirAtividadeCrmProposta", false);
    dispatch("setModalCadastroAtividadeCrmProposta", false);
    CrmPropostaAtividadeService.excluir(id)
      .then((res) => {
        dispatch("listarAtividadesCrmProposta", store.getters.getCrmProposta);
        commit("setOverlay", false);
        commit("snackbarError", "Registro excluído.");
      })
      .catch((e) => {
        console.log(e);
        commit("setOverlay", false);
        commit("snackbarError", "Erro ao excluir.");
      });
  },
  setModalCadastroAtividadeCrmProposta: ({ commit }, status) => {
    commit("setModalCadastroAtividadeCrmProposta", false);
    setTimeout(() => {
      commit("setModalCadastroAtividadeCrmProposta", status);
    }, 100);
  },
  setModalExcluirAtividadeCrmProposta: ({ commit }, status) => {
    commit("setModalExcluirAtividadeCrmProposta", false);
    setTimeout(() => {
      commit("setModalExcluirAtividadeCrmProposta", status);
    }, 100);
  },
};

export default {};
